import React, { useEffect, useRef } from 'react';
import logo1 from "./images/logo1.webp";
import logo2 from "./images/logo2.webp";
import logo3 from "./images/logo3.webp";
import logo4 from "./images/logo4.webp";
import logo5 from "./images/logo5.webp";
import logo6 from "./images/logo6.webp";
import logo7 from "./images/logo7.webp";
import logo8 from "./images/logo8.webp";
import logo9 from "./images/logo9.webp";
import logo10 from "./images/logo10.webp";

const Our_Clints = () => {
  const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10];

  // ⬇️ Reveal-on-view (bottom → top fade)
  const sectionRef = useRef(null);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('reveal-up');
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-5 position-relative pre"
      style={{ overflow: 'hidden' }}
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{ maxWidth: '74%', zIndex: 1 }}
      >
        {/* Heading */}
        <div style={{ marginTop: '80px', textAlign: "center" }}>
          <h2
            style={{
              fontSize: "2.5rem",
              fontFamily: "Inter",
              fontWeight: 700,
              color: "#242121ff",
              lineHeight: 1.2,
            }}
          >
            Our Clients
          </h2>
          <p
            className="mt-2"
            style={{
              marginTop: -2,
              color: "#413e3eff",
              fontSize: "1.1rem",
              fontFamily: "Poppins",
              fontWeight: 300,
              lineHeight: 1.2,
            }}
          >
            Trusted by leading enterprises, government bodies and fast-growing startups who count on us to deliver secure, scalable and impactful digital solutions that drive innovation, efficiency and long-term growth.
          </p>
        </div>

        {/* Logos auto-scroll + LEFT + RIGHT fade */}
        <div
          className="logo-rail"
          style={{
            marginTop: "50px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <div className="logo-scroll">
            {logos.concat(logos).map((logo, idx) => (
              <img
                key={idx}
                src={logo}
                alt={`client-${idx}`}
                style={{
                  height: "100px",
                  width: "auto",
                  margin: "0 40px",
                  display: "inline-block",
                  objectFit: "contain",
                }}
              />
            ))}
          </div>

          {/* Fade overlays */}
          <span className="fade-edge left" />
          <span className="fade-edge right" />
        </div>
      </div>

      {/* Animation CSS */}
      <style>{`
        /* entrance: bottom → top fade */
        .pre { opacity: 0; transform: translateY(24px); }
        .reveal-up { animation: fadeUp 700ms ease-out forwards; }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* continuous auto-scroll (faster speed) */
        .logo-scroll {
          display: inline-block;
          white-space: nowrap;
          animation: scroll-left 3s linear infinite; /* speed up from 4s -> 3s */
        }
        @keyframes scroll-left {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }

        /* Fade edges */
        .logo-rail .fade-edge {
          position: absolute;
          top: 0;
          height: 100%;
          width: 120px;
          pointer-events: none;
        }
        .logo-rail .fade-edge.left {
          left: 0;
          background: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0));
        }
        .logo-rail .fade-edge.right {
          right: 0;
          background: linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0));
        }

        /*  Default: black & white logos while scrolling */
        .logo-rail .logo-scroll img{
          filter: grayscale(1) saturate(0) brightness(.96) contrast(1.05);
          opacity: .85;
          transition: filter .25s ease, opacity .25s ease, transform .25s ease;
          will-change: filter, opacity, transform;
        }

        /* Hover anywhere on rail: pointer + color restore */
        .logo-rail:hover { cursor: pointer; }
        .logo-rail:hover .logo-scroll img{
          filter: none;
          opacity: 1;
        }

        /* Optional: tiny lift on individual logo hover */
        .logo-rail:hover .logo-scroll img:hover{
          transform: translateY(-4px);
        }

        /* Ensure animation never pauses on hover */
        .logo-rail .logo-scroll{
          animation-play-state: running !important;
        }

        .logo-rail:hover .logo-scroll{
  animation-play-state: paused !important;
}
      `}</style>
    </section>
  );
};


export default Our_Clints